import React, { useState } from "react";
import { Col, Form, Row, Tab, Tabs } from "react-bootstrap";
import toast from "react-hot-toast";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import Delete from "../../../Components/Modals/DeleteModal";
import Navbar from "../../../Components/Navbar/Navbar";
import Table from "../../../Components/TableTemplate/Table";
import AdjustmentTable from "./../../Inventory/Adjustment/AdjustmentTable";
import {
    dateFormat,
    formatDateNoTime,
    formatDate,
    numberFormat,
    refreshPage,
    toastStyle,
    getTodayDate,
    getType,
    TokenExpiry,
    getTime,
    getTodayDateISO
} from "../../../Helpers/Utils/Common";
import DatePicker from "react-datepicker";
import Moment from "moment";
import { CSVLink, CSVDownload } from "react-csv";
import downloadIcon from "../../../Assets/Images/download_icon.png";

import { getAllFranchisee } from "../../../Helpers/apiCalls/franchiseeApi";
import { searchWastage, deleteWastage } from "../../../Helpers/apiCalls/Reports/DailyWastageApi";
import { getAllBranches } from "../../../Helpers/apiCalls/Manage/Branches";
import { getAllItems } from "../../../Helpers/apiCalls/itemsApi";
import { searchDailyUsage } from './../../../Helpers/apiCalls/Reports/DailyUsageApi';
import { getAllProducts } from './../../../Helpers/apiCalls/Manage/Products';
import { getStoreDiscountReport } from './../../../Helpers/apiCalls/Reports/DailyOrdersApi';
import { getTotalSalesReport, getTotalSalesReportPotato } from './../../../Helpers/apiCalls/Reports/TotalSalesReportApi';

export default function TotalSalesReport() {
    let navigate = useNavigate();
    var dateToday = getTodayDate();
    const accountType = getType();

    const [inactive, setInactive] = useState(true);
    const [filterConfig, setFilterConfig] = useState({
        transaction_type: "store",
        tab: "mango"
    })
    const [branches, setBranches] = useState([]);
    const [showLoader, setShowLoader] = useState(false);
    const [allData, setAllData] = useState([]);
    const [totalQuantity, setTotalQuantity] = useState(0);
    const [totalSales, setTotalSales] = useState(0);
    const [totalAvgSales, setTotalAvgSales] = useState(0);
    const [selectedRow, setSelectedRow] = useState([]);
    const [items, setItems] = useState([]);
    const today = Moment().format("MM/DD/YYYY");

    const excelHeaders = [
        { label: "DATE", key: "sales_date" },
        { label: "BRANCH", key: "branch" },
        { label: "GRAND TOTAL SALES", key: "total_sales" },
        { label: "AVG SALES PER DAY", key: "avg_sales" },
    ];

    const handleTabSelect = (key) => {
        setFilterConfig((prev) => {
            return {
                ...prev,
                tab: key,
                date_from: "",
                date_to: "",
            };
        });
    };

    async function fetchBranches() {

        const response = await getAllBranches();
        if (response.error) {
        } else {
            var allBranches = response.data.data.data
            .filter((data) => { return data.is_franchise !== "3"})
            .map((data) => {
                var branch = data;
                branch.label = data.name
                branch.value = data.id
                return branch;
            });
            setBranches([{label: "All Branches", value:""}, ...allBranches]);
        }
    }
    
    async function fetchAllProducts() {
        const response = await getAllProducts();

        if (response.data) {
            var data = response.data.data.data.map((item) => {
                var info = item;
                info.label = item.name
                info.value = item.id
                return info;
            });
            setItems([{label: "All Products", value:""}, ...data]);
        } else {
        }
    }

    async function fetchData() {
        setShowLoader(true);
        setAllData([])
        setTotalQuantity(0);
        setTotalSales(0);
        setTotalAvgSales(0);

        if(filterConfig.tab === "mango") {
            const response = await getTotalSalesReport(filterConfig);
            

            if (response.error) {
            } else {

                var allBills = response.data.total_sales_per_branch.map((bill) => {
                    var items = ""
                    var info = bill;
                    info.sales_date = Moment(bill.sales_date).format("MM-DD-YYYY")
                    info.total_sales = numberFormat(bill.total_sales)
                    info.avg_sales = numberFormat(bill.avg_sales)
                    return info;
                });
                setAllData(allBills)

                // var total_qty = response.data.summary? response.data.summary.total_qty : "0";
                var total_sales = response.data.total_sales? response.data.total_sales : "0";
                var total_discount = response.data.total_avg_sales? response.data.total_avg_sales : "0";
                // setTotalQuantity(total_qty);
                setTotalSales(total_sales);
                setTotalAvgSales(total_discount);
            }
            setShowLoader(false);
        } else if(filterConfig.tab === "potato") {
            const response = await getTotalSalesReportPotato(filterConfig);
            

            if (response.error) {
            } else {

                var allBills = response.data.data.map((bill) => {
                    var items = ""
                    var info = bill;
                    info.sales_date = Moment(bill.sales_date).format("MM-DD-YYYY")
                    info.total_sales = numberFormat(bill.total_sales)
                    info.avg_sales = numberFormat(bill.avg_sales)
                    return info;
                });
                setAllData(allBills)

                // var total_qty = response.data.summary? response.data.summary.total_qty : "0";
                var total_sales = response.data.summary? response.data.summary.total_sales : "0";
                var total_discount = response.data.summary? response.data.summary.total_discount : "0";
                // setTotalQuantity(total_qty);
                setTotalSales(total_sales);
                setTotalAvgSales(total_discount);
            }
            setShowLoader(false);
        }
    }

    React.useEffect(() => {
        fetchBranches();
        // fetchAllProducts()
    }, []);

    React.useEffect(() => {
        fetchData();
    }, [filterConfig]);

    return (
        <div>
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"STORE REPORTS"}
                />
            </div>

            <div
                className={`manager-container ${
                    inactive ? "inactive" : "active"
                }`}
            >
                {/* headers */}
                <Row className="mb-2">
                    <Col xs={6}>
                        <h1 className="page-title"> TOTAL SALES REPORT </h1>
                    </Col>
                </Row>

                <Row>
                    <Col className="d-flex justify-content-end mb-4">
                        <div className="justify-content-center align-items-center ">
                            <CSVLink
                                className="button-primary px-3 py-3 justify-content-center align-items-center download-csv"
                                data={allData}
                                headers={excelHeaders}
                                target="_blank"
                                filename={`${getTodayDateISO()} 'TotalSalesReport'`}
                            >
                                <span className="me-2">
                                    <img
                                        width={20}
                                        height={20}
                                        src={downloadIcon}
                                    ></img>
                                </span>
                                Download Excel
                            </CSVLink>
                        </div>
                    </Col>
                </Row>

                
                <Tabs
                    activeKey={filterConfig.shop}
                    // defaultActiveKey={filterConfig.shop}
                    id="PO-tabs"
                    className="manager-tabs"
                    onSelect={handleTabSelect}
                >
                    <Tab eventKey="mango" title="Mango Magic">
                        <div className="tab-content">
                            {/* filters */}
                            <div className="my-2 px-2 PO-filters d-flex">
                                <span className="me-4 align-middle mt-2 ps-label">
                                    Filter By:
                                </span>

                                <Select
                                    className="dropsearch-filter px-0 py-0 me-2"
                                    classNamePrefix="react-select"
                                    placeholder="Select Branch"
                                    styles={{
                                        control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        backgroundColor: state.isSelected ? 'white' : 'var(--primary-color)',
                                        borderRadius: "7px",
                                        border: "0px",
                                        minHeight: "20px",
                                        maxHeight: "35px",
                                        }),
                                        input: (baseStyles, state) => ({
                                            ...baseStyles,
                                            color: state.isSelected? "white": "white",
                                            
                                        }),
                                        dropdownIndicator: (baseStyles, state) => ({
                                            ...baseStyles,
                                            color: "white"
                                            
                                        }),
                                        singleValue: (baseStyles, state) => ({
                                            ...baseStyles,
                                            color: "white"
                                            
                                        }),
                                        placeholder: (baseStyles, state) => ({
                                            ...baseStyles,
                                            color: "white"
                                            
                                        }),
                                        
                                    }}
                                    options={branches}
                                    onChange={(e) => { setFilterConfig((prev) => {
                                            return { ...prev, "branch_id": e.value };
                                        });}}
                                />

                                <span className="me-4 align-middle mt-2 ps-label">
                                    From:
                                </span>
                                <DatePicker
                                    autoComplete="off"
                                    selected={filterConfig.date_from}
                                    name="date_from"
                                    placeholderText={today}
                                    onChange={(date) => {
                                        setFilterConfig((prev) => {
                                            return { ...prev, date_from: date };
                                        });
                                    }}
                                    fixedHeight
                                    className="PI-date-btn me-3 form-control"
                                    showYearDropdown
                                    dateFormatCalendar="MMMM"
                                    yearDropdownItemNumber={20}
                                    scrollableYearDropdown
                                />

                                <span className="me-4 align-middle mt-2 ps-label">
                                    To:
                                </span>
                                <DatePicker
                                    autoComplete="off"
                                    selected={filterConfig.date_to}
                                    name="date_to"
                                    placeholderText={today}
                                    onChange={(date) => {
                                        setFilterConfig((prev) => {
                                            return { ...prev, date_to: date };
                                        });
                                    }}
                                    fixedHeight
                                    className="PI-date-btn me-3 form-control"
                                    showYearDropdown
                                    dateFormatCalendar="MMMM"
                                    yearDropdownItemNumber={20}
                                    scrollableYearDropdown
                                />
                            </div>

                            <div className=" PO-filters d-flex justify-content-center">
                                <span className="me-4 ml-4 mt-2 ps-label">
                                    Total Sales: {numberFormat(totalSales)}
                                </span>
                                <span className="me-4 ml-4 mt-2 ps-label">
                                    Average Sales Per Day: {numberFormat(totalAvgSales)}
                                </span>
                            </div>

                            <div className="below">
                                {/* table */}
                                <Table
                                    tableHeaders={[
                                        // "DATE",
                                        "BRANCH",
                                        "GRAND TOTAL SALES",
                                        "AVG SALES PER DAY",
                                    ]}
                                    headerSelector={[
                                        // "sales_date",
                                        "branch",
                                        "total_sales",
                                        "avg_sales",
                                    ]}
                                    tableData={allData}
                                    showLoader={showLoader}
                                />
                            </div>
                            <div className="mb-2" />
                        </div>
                    </Tab>
                    <Tab eventKey="potato" title="Potato Corner">
                        <div className="tab-content">
                            {/* filters */}
                            <div className="my-2 px-2 PO-filters d-flex">
                                <span className="me-4 align-middle mt-2 ps-label">
                                    Filter By:
                                </span>

                                <Select
                                    className="dropsearch-filter px-0 py-0 me-2"
                                    classNamePrefix="react-select"
                                    placeholder="Select Branch"
                                    styles={{
                                        control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        backgroundColor: state.isSelected ? 'white' : 'var(--primary-color)',
                                        borderRadius: "7px",
                                        border: "0px",
                                        minHeight: "20px",
                                        maxHeight: "35px",
                                        }),
                                        input: (baseStyles, state) => ({
                                            ...baseStyles,
                                            color: state.isSelected? "white": "white",
                                            
                                        }),
                                        dropdownIndicator: (baseStyles, state) => ({
                                            ...baseStyles,
                                            color: "white"
                                            
                                        }),
                                        singleValue: (baseStyles, state) => ({
                                            ...baseStyles,
                                            color: "white"
                                            
                                        }),
                                        placeholder: (baseStyles, state) => ({
                                            ...baseStyles,
                                            color: "white"
                                            
                                        }),
                                        
                                    }}
                                    options={branches}
                                    onChange={(e) => { setFilterConfig((prev) => {
                                            return { ...prev, "branch_id": e.value };
                                        });}}
                                />

                                <span className="me-4 align-middle mt-2 ps-label">
                                    From:
                                </span>
                                <DatePicker
                                    autoComplete="off"
                                    selected={filterConfig.date_from}
                                    name="date_from"
                                    placeholderText={today}
                                    onChange={(date) => {
                                        setFilterConfig((prev) => {
                                            return { ...prev, date_from: date };
                                        });
                                    }}
                                    fixedHeight
                                    className="PI-date-btn me-3 form-control"
                                    showYearDropdown
                                    dateFormatCalendar="MMMM"
                                    yearDropdownItemNumber={20}
                                    scrollableYearDropdown
                                />

                                <span className="me-4 align-middle mt-2 ps-label">
                                    To:
                                </span>
                                <DatePicker
                                    autoComplete="off"
                                    selected={filterConfig.date_to}
                                    name="date_to"
                                    placeholderText={today}
                                    onChange={(date) => {
                                        setFilterConfig((prev) => {
                                            return { ...prev, date_to: date };
                                        });
                                    }}
                                    fixedHeight
                                    className="PI-date-btn me-3 form-control"
                                    showYearDropdown
                                    dateFormatCalendar="MMMM"
                                    yearDropdownItemNumber={20}
                                    scrollableYearDropdown
                                />
                            </div>

                            <div className=" PO-filters d-flex justify-content-center">
                                <span className="me-4 ml-4 mt-2 ps-label">
                                    Total Sales: {numberFormat(totalSales)}
                                </span>
                                <span className="me-4 ml-4 mt-2 ps-label">
                                    Average Sales Per Day: {numberFormat(totalAvgSales)}
                                </span>
                            </div>

                            <div className="below">
                                {/* table */}
                                <Table
                                    tableHeaders={[
                                        "DATE",
                                        "BRANCH",
                                        "GRAND TOTAL SALES",
                                        "AVG SALES PER DAY",
                                    ]}
                                    headerSelector={[
                                        "sales_date",
                                        "branch",
                                        "total_sales",
                                        "avg_sales",
                                    ]}
                                    tableData={allData}
                                    showLoader={showLoader}
                                />
                            </div>
                            <div className="mb-2" />
                        </div>
                    </Tab>
                </Tabs>

                
            </div>
        </div>
    );
}
